__turbopack_context__.v({
  "navItem": "NavBar-module__aMivtW__navItem",
  "overlap": "NavBar-module__aMivtW__overlap",
  "overlapActive": "NavBar-module__aMivtW__overlapActive",
  "stateInput": "NavBar-module__aMivtW__stateInput",
  "subItems": "NavBar-module__aMivtW__subItems",
});
